<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>满送</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.query.id ? '编辑满送' : '添加满送'}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                            class="formValidate mt20"
                            ref="formValidate"
                            :rules="ruleValidate"
                            :model="formValidate"
                            :label-width="90"
                            @submit.native.prevent>
                        <FormItem label="满送名称：" prop="mansong_name">
                            <Input
                                    v-model="formValidate.mansong_name"
                                    placeholder="请输入满送名称"
                                    v-width="'50%'"/>
                        </FormItem>
                        <Col span="24">
                            <FormItem label="活动时间：" prop="section_time">
                                <div class="acea-row row-middle">
                                    <DatePicker :editable="false" type="datetimerange" format="yyyy/MM/dd" placeholder="请选择活动时间"
                                                @on-change="onchangeTime" class="perW30" :value="formValidate.section_time" v-model="formValidate.section_time"></DatePicker>
                                    <div class="ml10 ivu-form-item-content">设置活动开启结束时间，用户可以在设置时间内发起参与秒杀</div>
                                </div>
                                <div class="warn ivu-form-item-content">为保证活动时间的唯一性，添加活动后，活动时间不能修改！</div>
                            </FormItem>
                        </Col>
                        <FormItem label="满送类型：" prop="type">
                            <RadioGroup v-model="formValidate.type">
                                <Radio :label="10" class="radio">满N元</Radio>
                                <Radio :label="20">满N件</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="优惠内容：" prop="type">
                            <div class="list">
                                <div class="item mar_b20" v-for="(rule, index1) in formValidate.rule_json">
                                    <div class="title acea-row row-between-wrapper">
                                        <span>{{index1 + 1}}级优惠</span>
                                        <span class="del" @click="delRule(index1)" v-if="index1 !== 0">删除</span>
                                    </div>
                                    <FormItem label="优惠门槛：">
                                        <span class="ml10 mr10">满</span>
                                        <InputNumber class="ml10" v-model="rule.full_money" placeholder="门槛金额"></InputNumber>
                                        <span class="ml10 mr10">{{formValidate.type == 10 ? '元' : '件'}}</span>
                                    </FormItem>
                                    <FormItem label="优惠内容：">
                                        <vxe-table
                                            :border="false"
                                            class="vxeTable mt25"
                                            highlight-hover-row
                                            highlight-current-row
                                            ref="xTable"
                                            header-row-class-name="false"
                                            :data="rule.give_goods_id">
                                            <vxe-table-column title="商品信息"  tooltip min-width="250">
                                                <template v-slot="{ row }">
                                                    <div class="acea-row row-middle">
                                                        <viewer>
                                                            <div class="tabBox_img">
                                                                <img v-lazy="row.goods.product_pic_main">
                                                            </div>
                                                        </viewer>
                                                        <div class="ml10 name">{{row.goods.name}}[{{row.goods.sku_name}}]</div>
                                                    </div>
                                                </template>
                                            </vxe-table-column>
                                            <vxe-table-column title="售价"  tooltip min-width="60">
                                                <template v-slot="{ row, index }">
                                                    <div class="">
                                                        {{row.goods.price}}
                                                    </div>
                                                </template>
                                            </vxe-table-column>
                                            <vxe-table-column title="库存"  tooltip min-width="60">
                                                <template v-slot="{ row }">
                                                    <div class="">
                                                        {{row.goods.stock}}
                                                    </div>
                                                </template>
                                            </vxe-table-column>
                                            <vxe-table-column field="id" title="数量"  tooltip min-width="60">
                                                <template v-slot="{ row, index}">
                                                    <div class="" v-if="row">
                                                        <InputNumber v-model="row.goods_num"></InputNumber>
                                                    </div>
                                                </template>
                                            </vxe-table-column>
                                            <vxe-table-column field="action" title="操作"  min-width="150" fixed="right">
                                                <a @click="delGoods(rule.give_goods_id, index)">删除</a>
                                            </vxe-table-column>
                                        </vxe-table>
                                    </FormItem>
                                    <div class="ml90"><div class="bnt" @click="changeGoods(index1)">+ 添加赠品</div></div>
                                </div>
                            </div>
                            <div class="mar_t15 curs">
                                <div @click="addRule" class="mar_t15 color_primary">+ 添加满送</div>
                            </div>
                        </FormItem>
                        <FormItem label="启用状态：" prop="status">
                            <RadioGroup v-model="formValidate.status">
                                <Radio :label="1" class="radio">启用</Radio>
                                <Radio :label="0">关闭</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="满送描述：" prop="describe">
                            <Input type="textarea" v-model="formValidate.describe"
                                   placeholder="请输入满送描述"
                                   v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="" prop="">
                            <Button
                                    type="primary"
                                    class="submission"
                                    @click="handleSubmit('formValidate')">
                                保存
                            </Button>
                        </FormItem>
                    </Form>
                </Card>
            </div>
        </div>
        <!-- 选择商品-->
        <Modal v-model="modals" title="商品列表" footerHide  class="paymentFooter" scrollable width="900" @on-cancel="cancel">
            <goods-attr ref="goodslist" :in_store="1"  @getProductId="getProductId"></goods-attr>
        </Modal>
    </div>
</template>

<script>
    import goodsAttr from '@/components/goodsAttr/index';
    import { formatDate } from "@/utils/validate";
    import second from "./second.vue";
    export default {
        name: "add",
        components: { second, goodsAttr },
        data () {
            return {
                modals: false,
                modal_loading: false,

                isLoad: false,
                mansong_id: 0,
                record: false,
                formValidate: {
                    type: 10,
                    status: 1,
                    total_num: 0,
                    expire_type: 10,
                    apply_range: 10,
                    sort: 100,
                    between_time: [],
                    rule_json: [
                        {
                            full_money: 0,
                            give_goods_id: [
                            ]
                        }
                    ],
                },
                ruleValidate: {
                    mansong_name: [
                        {required: true, message: "请输入满送名称"},
                    ],
                    type: [
                        {required: true, message: "请选择满送类型"},
                    ],
                    reduce_price: [
                        {required: true, message: "请输入减免金额"},
                    ],
                    min_price: [
                        {required: true, message: "请输入最低消费金额"},
                    ],
                    expire_type: [
                        {required: true, message: "请选择到期类型"},
                    ],
                    expire_day: [
                        {required: true, message: "请输入有效期天数"},
                    ],
                    between_time: [
                        {required: true, message: "请选择有效期范围"},
                    ],
                    total_num: [
                        {required: true, message: "请输入发放总数量"},
                    ],
                    status: [
                        {required: true, message: "请选择显示状态"},
                    ],

                },
                ruleIndex: -1
            }
        },
        mounted() {
            if (this.$route.query.id !== "0" && this.$route.query.id) {
                this.getInfo();
            } else if (this.$route.query.id === "0") {
            }
        },
        methods: {
            // 商品id
            getProductId (row) {
                var _this = this
                this.modal_loading = false;
                this.modals = false;
                this.goods = row
                setTimeout(() => {
                    _this.formValidate.rule_json[this.ruleIndex].give_goods_id = [
                        {
                            goods_id: row.goods_id,
                            goods_num: 0,
                            unique: row.unique,
                            goods: row
                        }
                    ]
                    _this.$forceUpdate()
                }, 500);
            },
            cancel () {
                this.modals = false;
            },
            getInfo: function () {
                this.axios.post('store/app.mansong/detail', {
                    mansong_id: this.$route.query.id
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        // 当前记录
                        this.record = res.data.model
                        this.mansong_id = this.record.mansong_id
                        // 设置表单默认值
                        this.setFieldsValue()
                    }
                })
            },
            setFieldsValue: function () {
                const { record } = this

                // 表单数据
                const data = _.pick(record, [
                    'mansong_name', 'type', 'goods_type', 'mansong_type', 'rule_json', 'status', 'describe'
                ])
                data.section_time = [
                    formatDate(new Date(record.start_time * 1000), "yyyy/MM/dd"),
                    formatDate(new Date(record.end_time * 1000), "yyyy/MM/dd")
                ]

                this.formValidate = data
            },
            // 具体日期
            onchangeTime(e) {
                this.timeVal = e;
                if (e.length == 2) {
                    this.formValidate.between_time = this.timeVal
                }
            },
            // 提交
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var form = _.cloneDeep(this.formValidate)
                        if (this.mansong_id) {
                            this.axios.post('store/app.mansong/edit', {
                                mansong_id: this.mansong_id,
                                form: form
                            })
                            .then(async (res) => {
                                this.openSubimit = false;
                                this.$Message.success(res.msg);
                                setTimeout(() => {
                                    this.$router.push({path: "/app/mansong/list.html"});
                                }, 1500);
                            })
                            .catch((res) => {
                                this.openSubimit = false;
                                this.$Message.error(res.msg);
                            });
                        } else {
                            this.axios.post('store/app.mansong/add', {
                                form: form
                            })
                                .then(async (res) => {
                                    this.openSubimit = false;
                                    this.$Message.success(res.msg);
                                    setTimeout(() => {
                                        this.$router.push({path: "/app/mansong/list.html"});
                                    }, 500);
                                })
                                .catch((res) => {
                                    this.openSubimit = false;
                                    this.$Message.error(res.msg);
                                });
                        }
                    }
                })
            },
            delRule: function (index) {
                this.formValidate.rule_json.splice(index, 1)
            },
            addRule: function () {
                this.formValidate.rule_json.push({
                    full_money: 0,
                    give_goods_id: []
                })
            },
            // 选择商品
            changeGoods (index) {
                this.ruleIndex = index
                this.modals = true;
                this.$refs.goodslist.getList();
                this.$refs.goodslist.goodsCategory();
            },
            delGoods (row, index) {
                row.splice(index, 1)
                this.$forceUpdate()
            }
        }
    }
</script>

<style scoped>
    .list .item .title{
        width: 50%;
        height: 34px;
        background-color: #f5f7fa;
        padding: 0 15px;
    }
    .list .item .title .del{
        color: #f5222d;
        cursor: pointer;
    }
    .list .item .ivu-form-item {
        margin-top: 20px!important;
    }
    .formValidate .list .item .bnt{
        font-size: 13px;
        color: #1890ff;
        margin-top: 10px;
        cursor: pointer;
        width: 100px;
    }
    .ml90{
        margin-left: 90px;
    }
</style>
